import React from 'react';
import { KTSVG } from './KTSVG';

type Props = {
  user: any;
};

const UserImage: React.FC<Props> = ({ user }) => {
  return (
    <>
      {user ? (
        <>
          <div className="symbol symbol-40px tooltip-soft-board">
            {user && user.profile_photo ? (
              <>
                <img
                  src={`${process.env.REACT_APP_PUBLIC}users/${user.profile_photo}`}
                  title={`${user.nombre} ${user.apellido_paterno} ${user.apellido_materno}`}
                  crossOrigin="anonymous"
                  className="symbol-label fs-5 "
                  alt="user"
                />
                <span className="tooltipboard">{`${user.nombre} ${user.apellido_paterno}`}</span>
              </>
            ) : (
              <>
                <span
                  className="symbol-label fs-5 fw-bold bg-light-primary text-primary fw-bold"
                  title={`${user.nombre} ${user.apellido_paterno} ${user.apellido_materno}`}
                >{`${user.nombre[0]}${user.apellido_paterno[0]}`}</span>
                <span className="tooltipboard">{`${user.nombre} ${user.apellido_paterno}`}</span>
              </>
            )}
          </div>
        </>
      ) : (
        <>
          <span className="symbol symbol-40px cursor-pointer tooltip-soft-board">
            <div className="symbol-label" title="No asignado">
              <KTSVG
                path="/media/icons/duotune/communication/com006.svg"
                className="svg-icon-1"
              />
            </div>
            <span className="tooltipboard">No asignado</span>
          </span>
        </>
      )}
    </>
  );
};

export { UserImage };
